// extracted by mini-css-extract-plugin
export var link = "MobileHomeLink-module__link___nXSCT";